import {Getters} from "vuex-smart-module";
import WarehouseAdminState, {
    WarehouseAdminStatus
} from "@/store/modules/warehouse-admin/warehouse-admin-state";

function statusMessage(status: WarehouseAdminStatus): string {
    switch (status) {
        case WarehouseAdminStatus.Unauthenticated:
            return "You are not authenticated.";
        case WarehouseAdminStatus.Forbidden:
            return "You do not have access to warehouse admin.";
        case WarehouseAdminStatus.Failed:
            return "Warehouse admin could not be loaded.";
        default:
            return "";
    }
}

export default class WarehouseAdminGetters extends Getters<WarehouseAdminState> {
    get productsStatusMessage(): string {
        return statusMessage(this.state.productsStatus);
    }

    get productStatusMessage(): string {
        return statusMessage(this.state.productStatus);
    }

    get ordersStatusMessage(): string {
        return statusMessage(this.state.ordersStatus);
    }

    get orderStatusMessage(): string {
        return statusMessage(this.state.orderStatus);
    }

    get stockStatusMessage(): string {
        return statusMessage(this.state.stockStatus);
    }

    get restocksStatusMessage(): string {
        return statusMessage(this.state.restocksStatus);
    }

    get retoursStatusMessage(): string {
        return statusMessage(this.state.retoursStatus);
    }

    get restockHistoryStatusMessage(): string {
        return statusMessage(this.state.restockHistoryStatus);
    }

    get resupplyTasksStatusMessage(): string {
        return statusMessage(this.state.resupplyTasksStatus);
    }
}